export default {
  namespaced: true,
  state: () => {
    return {
      menuDataMap: {} // 使用对象存储不同 fid 的菜单数据，key 为 fid，value 为菜单数据
    }
  },
  mutations: {
    setMenuData(state, { fid, data }) {
      state.menuDataMap[fid] = data
    },
    clearMenuData(state) {
      state.menuDataMap = {}
    }
  },
  actions: {
    setMenuData({ commit }, { fid, data }) {
      commit('setMenuData', { fid, data })
    },
    clearMenuData({ commit }) {
      commit('clearMenuData')
    }
  },
  getters: {
    getMenuDataByFid: (state) => (fid) => {
      return state.menuDataMap[fid] || null
    }
  }
};
